module.exports = __webpack_public_path__ + "static/media/step-2.9f7c4234.png";